import { formatDate } from "app/DealMachineCore/actions/CommonFunctions";
import {
  Card,
  CardBody,
  Copy,
  Modal,
  ModalOverlay,
  Title,
  Row
} from "app/NativeComponents/common";
import { PillButton, TextButton } from "app/NativeComponents/snippets";
import React, { useEffect, useMemo, useRef, useState } from "react";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { SingleDatePicker } from "react-dates";
import moment from "moment";
import "./CompDateSelect.css";

export const CompDateSelect = ({ date, onDateChange, label = "" }) => {
  const [open, setOpen] = useState(false);
  const [internalDate, setInternalDate] = useState(moment(date));
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const bottomSheetRef = useRef(null);

  const onConfirm = () => {
    onDateChange(internalDate.toDate());
    setOpen(false);
  };

  useEffect(() => {
    if (!bottomSheetRef.current) return;
    if (open) bottomSheetRef.current.snapTo(1);
    else bottomSheetRef.current.collapse();
  }, [bottomSheetRef.current, open]);

  return (
    <>
      <PillButton
        innerStyle={{
          paddingTop: 5,
          paddingBottom: 5,
          paddingLeft: 15,
          paddingRight: 15
        }}
        onPress={() => setOpen(true)}
      >
        {formatDate(date)}
      </PillButton>
      {open && (
        <ModalOverlay>
          <Modal actionSheet>
            <Card
              style={{
                minWidth: "95%",
                paddingBottom: 0
              }}
            >
              <CardBody>
                <Title style={{ textAlign: "center" }}>Select a Date</Title>
                <Copy style={{ textAlign: "center" }}>{label}</Copy>
                <Row style={{ justifyContent: "center", paddingTop: "25px" }}>
                  <SingleDatePicker
                    date={internalDate}
                    isOutsideRange={() => false}
                    onDateChange={setInternalDate}
                    onFocusChange={({ focused }) => setOpenDatePicker(focused)}
                    focused={openDatePicker}
                    numberOfMonths={1}
                    id="comp-date"
                  />
                </Row>
              </CardBody>
              <Row style={{ justifyContent: "space-around" }}>
                <TextButton onPress={() => setOpen(false)} text={"Cancel"} />
                <TextButton onPress={onConfirm} text={"Confirm"} />
              </Row>
            </Card>
          </Modal>
        </ModalOverlay>
      )}
    </>
  );
};
